import { selectDoc, event, selectAll, select } from "../utils/utils";

export class Address {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.accountItem = selectAll('.js-editAddress');
    this.editForm = selectAll('.js-editForm');
    this.defaultAddress = selectAll('.js-setDefault');
    this.defaultEditForm = selectAll('.js-setDefaultEdit');
  }

  render() {
    this.setEdit();
    this.setDefault();
  }

  setDefault() {
    const defaultAddressEl = this.defaultAddress;
    const defaultEditFormEl = this.defaultEditForm;

    for(const defaultAddress of defaultAddressEl) {
      defaultAddress.addEventListener('click', () => {
        Array.from(defaultEditFormEl).find(defaultEdit => {
          if(defaultEdit.dataset.id === defaultAddress.dataset.id){
            defaultEdit.click();
            defaultEdit.closest('form').submit();
          }
        })
      })
    }
  }


  setEdit() {
    const editEl = this.accountItem;
    const editFormEl = this.editForm;

    for(const edit of editEl) {
      edit.addEventListener('click', () => {
        edit.closest('.js-accountAddress').classList.add('hide');
        Array.from(editFormEl).find(editForm => {
          editForm.dataset.id === edit.dataset.id ? editForm.classList.remove('hide') : editForm.classList.add('hide');
        })
      })
    }
  }
}
